import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import { Upload, CheckCircle2 } from "lucide-react";

export default function Setup() {
  const [status, setStatus] = useState(null);
  const [consulenti, setConsulenti] = useState(null);
  const [clienti, setClienti] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    api.get("/setup/status").then((r) => {
      setStatus(r.data);
      if (!r.data.needs_setup) nav("/", { replace: true });
    });
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!consulenti || !clienti) {
      setError("Carica entrambi i CSV.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("consulenti", consulenti);
      fd.append("clienti", clienti);
      await api.post("/setup/upload", fd);
      nav("/", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Errore durante il caricamento");
    } finally {
      setBusy(false);
    }
  };

  if (!status) return null;

  return (
    <div data-testid="setup-page">
      <Header />
      <div className="pa-container" style={{ padding: "40px 24px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: "var(--pa-navy)",
              marginBottom: 6,
            }}
          >
            Setup iniziale
          </h1>
          <p style={{ color: "var(--pa-muted)", marginBottom: 32, fontSize: 15 }}>
            Carica i due file CSV per popolare l'anagrafica di clienti e consulenti.
          </p>

          <form onSubmit={onSubmit} className="pa-card" style={{ padding: 28 }}>
            <FilePicker
              label="anagrafica_consulenti.csv"
              hint="id, nome, sede, parser_status"
              file={consulenti}
              onChange={setConsulenti}
              done={status.has_consulenti}
              testid="setup-consulenti-input"
            />
            <div style={{ height: 18 }} />
            <FilePicker
              label="anagrafica_clienti.csv"
              hint="codice, nome, consulente_id, forma_giuridica, tipo_struttura"
              file={clienti}
              onChange={setClienti}
              done={status.has_clienti}
              testid="setup-clienti-input"
            />

            {error && (
              <div
                style={{
                  marginTop: 16,
                  background: "var(--pa-red-bg)",
                  color: "var(--pa-red)",
                  padding: "10px 12px",
                  borderRadius: 8,
                  fontSize: 13,
                }}
                data-testid="setup-error"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              className="pa-btn-primary"
              disabled={busy || !consulenti || !clienti}
              data-testid="setup-submit-button"
              style={{
                marginTop: 24,
                padding: "10px 18px",
                borderRadius: 8,
                fontWeight: 600,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {busy ? <span className="pa-spinner" /> : <Upload size={16} />}
              {busy ? "Caricamento…" : "Carica anagrafiche"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

function FilePicker({ label, hint, file, onChange, done, testid }) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: 8,
        }}
      >
        <label style={{ fontWeight: 600, fontSize: 14, color: "var(--pa-text)" }}>
          {label}
        </label>
        {done && (
          <span
            style={{
              color: "var(--pa-green)",
              fontSize: 12,
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <CheckCircle2 size={14} /> Già caricato
          </span>
        )}
      </div>
      <p style={{ color: "var(--pa-muted)", fontSize: 12, margin: "0 0 8px" }}>
        Colonne richieste: {hint}
      </p>
      <input
        type="file"
        accept=".csv"
        onChange={(e) => onChange(e.target.files?.[0] || null)}
        data-testid={testid}
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid var(--pa-border)",
          borderRadius: 8,
          fontSize: 14,
          background: "white",
        }}
      />
      {file && (
        <div style={{ fontSize: 12, color: "var(--pa-muted)", marginTop: 6 }}>
          File selezionato: {file.name}
        </div>
      )}
    </div>
  );
}
